import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


// IMPORT GUARD FILES

import { AuthGuard } from './../../auth.guard';

// IMPORT COURSE MODULE COMPONENTS

import { MainSchedulerComponent } from './main-scheduler.component';
import { SchedulerComponent } from '../scheduler.component';
import { NewSchedularComponent } from '../new-schedular/new-schedular.component';

const routes: Routes = [
  {
    path: '',
    component: MainSchedulerComponent,
    children: [
      {
        path: 'view',
        component: SchedulerComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'planner',
        component: NewSchedularComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainSchedulerRoutingModule { }
